<template>
  <div class="tw-flex tw-flex-wrap tw-gap-3">
    <div
      v-for="value in values"
      :key="value.id"
      class="tw-flex tw-items-center tw-gap-3"
    >
      <button
        class="tw-px-3 tw-bg-white tw-shadow-sm tw-text-sm tw-py-1 tw-rounded-lg tw-text-[#F1583D] tw-flex tw-items-center tw-justify-between tw-font-medium tw-whitespace-nowrap tw-border tw-border-solid tw-border-[#DFE2E7] "
      >
        {{ value.name }}
        <i
          class="fas fa-times tw-ml-2 tw-text-[#79849A] tw-cursor-pointer"
          @click="removeValue(value.id)"
        />
      </button>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  components: { /* Subcomponents */ },
  props: {
    values: { type: Array, default: () => [] },
  },
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    removeValue(valueId) {
      console.log(`Removing value LOCAL: ${valueId}`);
      this.$emit('removeValue', valueId);
    },
  },
};
</script>


<style scoped>

</style>
